import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 21V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHouse3.js.map